import React from 'react'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { CurrencyIcon } from '@root/entities/currency/ui'
import { Trend } from '@root/entities/trend'
import { TrendIcon } from '@root/entities/trend/ui'

import type { CurrencyModel } from '@root/entities/currency'
import type { PairAddress } from '@root/entities/pair'

type Props = {
  currency: CurrencyModel
  pairAddress?: PairAddress
  trend: Trend.Trend | undefined
  onClick: ((event: React.MouseEvent) => void) | undefined
}

export const WalletAssetsCurrencyCell: React.FC<Props> = (props) => {
  return (
    <Root onClick={props.onClick} data-clickable={!!props.onClick}>
      <CurrencyIcon
        size={20}
        currency={props.currency}
        pairAddress={props.pairAddress}
        withNetwork
        withGoogleLens={false}
        auxIconSize={12}
      />
      <Title ellipsis>{props.currency.title}</Title>

      {!props.trend || props.trend === Trend.Neutral ? undefined : (
        <TrendIcon size={10} trend={props.trend} />
      )}
    </Root>
  )
}

const Title = styled(Typography)`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;

  margin-inline-start: 4px;

  transition: color 0.15s ease-in-out;
  color: var(--text-9);
`
const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 6px;

  &[data-clickable] {
    cursor: pointer;
    & ${Title}:hover {
      color: var(--text-11);
    }
  }
`
